import { TurnaroundTime as _TurnaroundTime } from '@team-milva/lab-models/resources'
import { getTextObjValue } from '@team-milva/lab-models/textObj'
import { t } from '@/locales'

// Mirrors lab-management's own TurnaroundTime model (same display rules) — a
// 'fixed-deadline' TAT has no user-entered name, so its label is always derived
// from workingDays/deadline; a 'walk-in' TAT uses its own ITextObj name.
export class TurnaroundTime extends _TurnaroundTime {
  getName(locale: string): string {
    if (this.type === 'fixed-deadline') {
      const hour = String(this.deadline.hour).padStart(2, '0')
      const minute = String(this.deadline.minute).padStart(2, '0')
      return t('tat.fixed-deadline-duration-text', {
        count: this.workingDays,
        time: `${hour}:${minute}`,
      })
    }
    return getTextObjValue(this.name, locale)
  }
}
